module.exports = __webpack_public_path__ + "img/galeria-agua-dulce-5.7849d93d.jpg";